import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() page: number = 1;
  @Input() totalPages: number = 1;
  @Input() listLength: number = 0;
  @Input() totalItems: number = 0;
  
  @Output() changePageEvent: EventEmitter<number> = new EventEmitter<number>();

  goToPage(page: number) {
    this.page = page;
    this.changePageEvent.emit(page);
  }

  getFirstNumber(): number {
    if( this.page == 1) {
      return 1;
    } else if(this.page > 1) {
      return (this.page - 1) * 10;
    }
  }

  getLastNumber(): number {
    if(this.page === this.totalPages) {
      return this.totalItems;
    } else {
      return this.page * 10;
    }
  }
}
